import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import get from 'lodash/get';
import { localizeDate as _localizeDate } from '@/utils/date';
export default {
  name: 'NiotaClassicGwMgmtMapDetail',
  props: {
    item: {
      type: Object,
      required: true
    },
    mapmode: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {};
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions', 'UiTheme'])), {}, {
    headerBG: function headerBG() {
      return './img/dtwin-factory1.png';
    },
    parallaxHeight: function parallaxHeight() {
      return this.mapmode ? 130 : 200;
    },
    showSkeletonLoader: function showSkeletonLoader() {
      return get(this.item, 'eui', true) === true;
    }
  }),
  methods: {
    lastPacket: function lastPacket(item) {
      return this.localizeDate(get(item, '_source.received_at_server')) || '-';
    },
    localizeDate: function localizeDate(item) {
      if (item) {
        return _localizeDate(item);
      }
    },
    getRssi: function getRssi(item) {
      return get(item, 'lastPacket._source.rssi') || 0;
    },
    getLsnr: function getLsnr(item) {
      return get(item, 'lastPacket._source.lsnr') || 0;
    },
    openDetails: function openDetails(item) {
      this.$router.push("/niota-classic/gw-mgmt/".concat(item.id, "/details"));
    }
  }
};